import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ProsesBantuan from "../../componen/bantuan/ProsesBantuan";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";
import { Layout } from "../../layout/Layout";

export const ProsesBantuanPages = () => {
     const dispatch = useDispatch();
        const navigate = useNavigate();
        const { isError } = useSelector((state) => state.authAdmin);
        const userRole = useSelector((state) => state.authAdmin?.user?.role);
      
        useEffect(() => {
          dispatch(getMeAdmin());
        }, [dispatch]);
      
        useEffect(() => {
          if (isError) {
            navigate("/");
          }
        }, [isError, navigate]);
        return(
            <Layout>
                <ProsesBantuan userRole={userRole} />
            </Layout>
        )
}

export const ProsesBantuanDetailPages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isError } = useSelector((state) => state.authAdmin);
  const userRole = useSelector((state) => state.authAdmin?.user?.role);

  useEffect(() => {
    dispatch(getMeAdmin());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <Layout>
      <ProsesBantuan userRole={userRole} inline inlineBantuanId={id ? Number(id) : null} />
    </Layout>
  );
}

export default ProsesBantuanPages;
